import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { getIsStartingImageSelectorOpen } from '../../redux/form/selectors';
import { loadPersistentFormValues } from '../../redux/form/actions';
import PromptInputDesktop from './PromptInput/dsPresets/PromptInputDesktop';
import PromptInputMobile from './PromptInput/dsPresets/PromptInputMobile';
import StartingImageSelector from './StartingImageSelector';
import { usePromptFormAction } from './usePromptFormAction';
import s from './PromptForm.scss';

interface Props {}

const PromptForm: React.FC<Props> = () => {
  const dispatchLoadPersistentFormValues = useAction(loadPersistentFormValues);
  const isMobile = useContext(MobileContext);
  const isStartingImageSelectorOpen = useSelector(
    getIsStartingImageSelectorOpen
  );
  const [handleSubmit, formAction] = usePromptFormAction();

  useEffect(() => {
    dispatchLoadPersistentFormValues();
  }, [dispatchLoadPersistentFormValues]);

  return (
    <>
      <div className={s['root']}>
        <form onSubmit={handleSubmit}>
          {isMobile ? (
            <PromptInputMobile formAction={formAction} />
          ) : (
            <PromptInputDesktop formAction={formAction} />
          )}
        </form>
      </div>
      <StartingImageSelector isOpen={isStartingImageSelectorOpen} />
    </>
  );
};

PromptForm.displayName = 'PromptForm';

export default PromptForm;
